export const SOURCE = 'JTBD_seamless_migration';

export const ICON_URL =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/973b353308e397c5135b06818930bf2a-1720078409844/Pro.png';
